import type en from "../en";

const ka: typeof en = {
  nav: {
    features: "შესაძლებლობები",
    pricing: "ფასები",
    integrations: "ინტეგრაციები",
    how: "როგორ მუშაობს",
    cta: "დაგვიკავშირდით",
    download: "ჩამოტვირთვა",
    apps: "აპლიკაციები",
    menu: "მენიუ",
    primary_nav: "მთავარი ნავიგაცია",
  },
  hero: {
    title_1: "ერთი მენიუ, ერთი საწყობის აღრიცხვა —",
    title_2: "მთელი დაწესებულება",
    title_3: "ერთ სისტემაში",
    subtitle:
      "თქვენი POS, საკუთარი მიწოდების პლატფორმა, QR მენიუ, ოფიციანტის აპლიკაცია, ეკრანები და საწყობი — ყველა ერთსა და იმავე მენიუზე მუშაობს. შეცვალეთ ფასი ერთხელ და ის იცვლება ყველგან. გაყიდეთ ბოლო პორცია და ის იმავე წამს ქრება თქვენი პლატფორმიდან.",
    cta_primary: "დაგვიკავშირდით",
    cta_secondary: "როგორ მუშაობს",
    trust: "პირველი თვე უფასოდ, სრული კომპლექტით · ჩვენი გუნდი აწყობს ყველაფერს",
    stat_venues_val: "20+",
    stat_venues: "დაწესებულება",
    stat_country: "უკვე საქართველოში",
    stat_payments: "ნაღდი · ბარათი · QR",
    stat_trial_val: "1 თვე",
    stat_trial: "უფასოდ",
    dashboard: {
      url: "samly.ge/dashboard",
      home: "მთავარი",
      orders: "შეკვეთები",
      menu: "მენიუ",
      kitchen: "სამზარეულო",
      analytics: "ანალიტიკა",
      staff: "პერსონალი",
      revenue_label: "დღევანდელი შემოსავალი",
      currency: "₾",
      orders_count: "შეკვეთა",
      avg_check: "საშ. ჩეკი",
      avg_time: "საშ. დრო",
      avg_time_val: "14 წუთი",
      paid: "გადახდილი",
      waiting: "მოლოდინში",
      order: "შეკვეთა",
      table: "მაგიდა",
    },
  },
  logos: {
    title: "მუშაობს ნებისმიერი ფორმატის დაწესებულებაში",
    formats: {
      restaurants: "რესტორნები",
      cafes: "კაფეები",
      oshkhona: "ხინკლის სახლები",
      fastfood: "ფასთფუდი",
      chains: "ქსელები",
    },
  },
  painpoints: {
    title: "სამი სისტემა — და სამივე სხვადასხვანაირად ითვლის",
    subtitle:
      "თქვენი POS, Excel-ში საწყობის ცხრილი და სხვისი აპლიკაციის პლატფორმა ერთმანეთის შესახებ არაფერს არ იცის. ამის შესახებ სტუმრისგან იგებთ.",
    before_label: "Samly-ის გარეშე",
    after_label: "Samly-სთან ერთად",
    before: [
      "ფასს POS-ში ცვლით — მიწოდების პლატფორმაზე ძველი ფასი კვლავ ჩანს",
      "ხაჭაპური დასრულდა, მაგრამ მასზე შეკვეთები კვლავ შემოდის",
      "საწყობი Excel-შია, POS — ცალკე, მიწოდება — აგრეგატორზე",
      "ოფიციანტი სტუმარს ჰპირდება კერძს, რომელიც სამზარეულოში აღარ არის",
      "ერთი ანგარიშის შედგენა სამი ექსპორტის ხელით შედარებას ნიშნავს",
    ],
    after: [
      "ფასს ერთხელ ცვლით — ის იცვლება ყველა გაყიდვის წერტილში",
      "გაყიდეთ ბოლო პორცია და კერძი ქრება პლატფორმიდან",
      "საწყობი, POS და მიწოდება ერთსა და იმავე მარაგს ითვლის",
      "სტოპ-ლისტი ერთდროულად ეწვევა ოფიციანტს, სამზარეულოსა და სტუმარს",
      "ერთი ანგარიში მთელი დაწესებულებისთვის — შესადარებელი აღარაფერია",
    ],
  },
  onemenu: {
    tag: "როგორ მუშაობს",
    title: "ერთი მენიუ. ერთი საწყობის აღრიცხვა. ექვსი გაყიდვის წერტილი.",
    subtitle: "მენიუსა და საწყობს ერთ ადგილას ინახავთ. დანარჩენს Samly აქტუალურს ხდის.",
    hub_title: "ერთი მენიუ",
    hub_sub: "ერთი საწყობის აღრიცხვა",
    surfaces: {
      pos: "POS",
      storefront: "საკუთარი მიწოდება",
      qr: "QR მენიუ",
      waiter: "ოფიციანტის აპლიკაცია",
      screens: "ეკრანები",
      warehouse: "საწყობი",
    },
    moments: [
      {
        title: "შეცვალეთ ფასი ერთხელ",
        desc: "ახალი ფასი მაშინვე ჩანს POS-ში, QR მენიუში, თქვენს მიწოდების პლატფორმაზე, ოფიციანტის აპლიკაციასა და ეკრანებზე. დუბლირება საჭირო არ არის.",
      },
      {
        title: "გაყიდეთ ბოლო პორცია",
        desc: "კერძი იმავე წამს ხვდება სტოპ-ლისტში: ის ქრება პლატფორმიდან, სტუმარი მას აღარ ხედავს, ოფიციანტი კი მას ვეღარ შეკვეთავს.",
      },
      {
        title: "საწყობი ინგრედიენტებს ითვლის",
        desc: "ყველა კერძს აქვს რეცეპტი. გაყიდეთ ხაჭაპური და საწყობიდან გადის ფქვილი, ყველი და მაწონი. თქვენი საწყობის მაჩვენებელი რეალურია და არა შეფასებითი.",
      },
    ],
  },
  stats: {
    items: [
      { val: "20+", label: "დაწესებულება", sub: "მუშაობს Samly-ზე" },
      { val: "1 თვე", label: "უფასოდ", sub: "სრული კომპლექტი, ბარათის გარეშე" },
      { val: "8", label: "კომპონენტი", sub: "იხდით მხოლოდ საკუთარისთვის" },
      { val: "−30%", label: "წლიური გადახდისას", sub: "მინიმუმ 3-თვიანი ვადა" },
    ],
  },
  features: {
    title: "ექვსი გაყიდვის წერტილი, ერთი მენიუ საფუძვლად",
    subtitle: "ჩართეთ ის, რაც თქვენს დაწესებულებას სჭირდება. დანარჩენს უბრალოდ არ ყიდულობთ.",
    tabs: {
      pos: "POS",
      storefront: "საკუთარი მიწოდება",
      qr: "QR მენიუ",
      waiter: "ოფიციანტის აპლიკაცია",
      kitchen: "სამზარეულო",
      warehouse: "საწყობი",
    },
    mock: {
      hall: "დარბაზი · 12 მაგიდა",
      st_free: "თავისუფალი",
      st_paid: "გადახდილი",
      st_waiting: "მოლოდინში",
      st_ordered: "შეკვეთილი",
      accept_payment: "მიიღეთ გადახდა",
      pin: "PIN",
      my_tables: "ჩემი მაგიდები",
      online: "ონლაინ",
      guests: "სტუმარი",
      positions: "პოზიცია",
      cooking: "მზადდება",
      ready: "მზადაა",
      accepted: "მიღებულია",
      kitchen_station: "სამზარეულო · ცხელი საამქრო",
      delivery: "მიწოდება",
      storefront_head: "თქვენი პლატფორმა · Telegram",
      add_to_cart: "კალათაში დამატება",
      sold_out: "გაყიდულია",
      checkout: "გადახდა",
      warehouse_head: "იჭრება რეცეპტის მიხედვით",
      warehouse_sold: "გაიყიდა 1 ხაჭაპური",
      warehouse_left: "დარჩა",
      stop_list: "სტოპ-ლისტი",
      table: "მაგიდა",
      total: "სულ",
      currency: "₾",
      your_order: "თქვენი შეკვეთა",
      pay_click: "გადაიხადეთ ბარათით",
      pay_payme: "დაუძახეთ ოფიციანტს",
      dishes: {
        plov: "ხაჭაპური",
        lagman: "ხინკალი",
        tea: "ჩაი",
        shashlik: "მწვადი",
        manti: "ლობიანი",
        soup: "ხარჩო",
        salad: "სალათი",
      },
      units: { g: "გ", kg: "კგ", ml: "მლ", l: "ლ" },
      ingredients: {
        rice: "ფქვილი",
        oil: "მაწონი",
        meat: "სულგუნი",
        carrot: "კვერცხი",
      },
    },
    pos: {
      title: "POS, რომელმაც იცის რეალური მარაგი",
      points: [
        "ნაღდი ფული, ბარათი და QR ერთ ფანჯარაში",
        "თანხის დაბრუნება, ფასდაკლება და წაშლა მენეჯერის PIN-ს საჭიროებს",
        "ცვლები და სალაროს ხარვეზები კონტროლის ქვეშაა",
        "ქვითრები ნებისმიერ ESC/POS ან StarPRNT პრინტერზე იბეჭდება",
        "მუშაობს ინტერნეტის გარეშეც და შემდეგ სინქრონიზდება",
      ],
    },
    storefront: {
      title: "საკუთარი პლატფორმა, არა თაროზე დადებული სხვისი აპლიკაცია",
      points: [
        "Telegram Mini App, ვებგვერდი და მობილური აპლიკაცია",
        "საკუთარი დომენი — სტუმრები ხედავენ თქვენს ბრენდს, არა მარკეტფლეისს",
        "მიწოდებისას გადახდა ნაღდი ფულით ან ბარათით",
        "შეკვეთები პირდაპირ ხვდება POS-სა და სამზარეულოში",
        "საკუთარ შეკვეთებზე აგრეგატორის საკომისიო არ არსებობს",
      ],
    },
    qr: {
      title: "სტუმრები საკუთარი ტელეფონიდან უკვეთავენ",
      points: [
        "მაგიდაზე დადებული QR კოდი ბრაუზერში ხსნის მენიუს — აპლიკაციის გარეშე",
        "ერთი საერთო კალათა მთელი მაგიდისთვის",
        "შეკვეთა პირდაპირ სამზარეულოში მიდის",
        "იგივე მენიუ და იგივე მარაგი, რაც POS-ში",
        "სტუმრები შეკვეთის სტატუსს ხედავენ კითხვის მაგივრად",
      ],
    },
    waiter: {
      title: "ოფიციანტი ვერ გაყიდის იმას, რაც არ გაქვთ",
      points: [
        "პლანშეტი ან ნებისმიერი Android ტელეფონი",
        "სტოპ-ლისტი რეალურ დროში განახლდება",
        "შენიშვნა თითოეულ კერძზე: ხახვის გარეშე, დამატებით ცხარე",
        "მაგიდის შეკვეთაში დამატება მისი თავიდან აგების გარეშე",
        "push შეტყობინება, როცა კერძი მზადაა",
      ],
    },
    kitchen: {
      title: "მზარეული ხედავს შეკვეთას, არა ქაღალდის ჩეკს",
      points: [
        "ავტომატური მარშრუტიზაცია საამქროების მიხედვით: ცხელი, ცივი, ბარი",
        "თითო კერძზე ტაიმერი, აღებული მისი რეცეპტიდან",
        "სტატუსები: მზადდება → მზადაა → ოფიციანტი გაფრთხილებულია",
        "მომზადების დროის ანალიტიკა თითოეული მზარეულისთვის",
        "შედის ტარიფში, დამატებითი გადასახადის გარეშე",
      ],
    },
    warehouse: {
      title: "საწყობი ითვლის ინგრედიენტებს, არა პორციებს",
      points: [
        "რეცეპტის ბარათი ყველა კერძისთვის",
        "გაყიდეთ ხაჭაპური და გამოიკლება ფქვილი, ყველი და მაწონი",
        "თვითღირებულება და მარჟა თითოეულ პოზიციაზე",
        "სტოპ-ლისტი თავად შედგება, როცა ინგრედიენტი მთავრდება",
        "რამდენიმე საწყობი, თუ ერთზე მეტ სამზარეულოს მართავთ",
      ],
    },
  },
  integrations: {
    title: "მუშაობს იმასთან, რასაც უკვე იყენებთ",
    subtitle: "გადახდები, მიწოდება და აღჭურვილობა — ყუთიდან ამოღებისთანავე.",
    soon: "მალე დაემატება",
    groups: {
      payment: {
        title: "გადახდები",
        items: [
          { name: "ნაღდი ფული, ბარათი, QR", desc: "ნებისმიერი საბანკო ტერმინალი სალაროსთან" },
          { name: "TBC Pay", logo: "/partners/tbc.svg", desc: "დაგეგმილია", soon: true },
          { name: "საქართველოს ბანკი", logo: "/partners/bank-of-georgia.svg", desc: "დაგეგმილია", soon: true },
        ],
      },
      delivery: {
        title: "მიწოდება",
        items: [
          { name: "საკუთარი პლატფორმა", desc: "Telegram, ვები, მობილური აპლიკაცია" },
          { name: "Wolt", logo: "/partners/wolt.png", desc: "დაგეგმილია", soon: true },
          { name: "Glovo", logo: "/partners/glovo.png", desc: "დაგეგმილია", soon: true },
        ],
      },
      equipment: {
        title: "აღჭურვილობა",
        items: [
          { name: "ESC/POS", desc: "ნებისმიერი ქვითრის პრინტერი" },
          { name: "StarPRNT", desc: "ქვითრის ავტომატური ბეჭდვა" },
          { name: "Smart TV / Fire Stick", desc: "მენიუს ეკრანებისთვის" },
        ],
      },
      local: {
        title: "პლატფორმა",
        items: [
          { name: "Android / iOS", desc: "ნებისმიერი მოწყობილობა" },
          { name: "Open API", desc: "საკუთარი ინტეგრაციები, ჩართულია" },
        ],
      },
    },
  },
  dashboardPreview: {
    owner: {
      badge: "მფლობელი",
      title: "ყველა ფილიალი ერთ ეკრანზე",
      features: {
        revenue: "რეალურ დროში შემოსავალი ყველა ფილიალში",
        alert: "შეტყობინება იმავე წამს, როცა ცვლა სხვაობით იხურება",
        reports: "ავტომატური ანგარიში ყოველი ცვლისთვის",
      },
      cta: "იხილეთ შესაძლებლობები",
      mockup: {
        title: "3 ფილიალი · დღეს",
        live: "ცოცხალი",
        revenue: "₾",
        week: "წინა კვირასთან შედარებით",
        branches: {
          chilanzar: "ვაკე",
          yunusabad: "საბურთალო",
          samarkand: "ბათუმი",
        },
      },
    },
    qr: {
      badge: "QR მენიუ",
      title: "სტუმრები თავად უკვეთავენ და იხდიან",
      features: {
        no_app: "აპლიკაცია არ სჭირდება — უბრალოდ მიმართეთ კამერა",
        payments: "შეკვეთა წამებში აღწევს სამზარეულოში",
        cart: "ერთი საერთო კალათა მთელი მაგიდისთვის",
      },
      cta: "როგორ მუშაობს QR მენიუ",
      slides: {
        menu: "მენიუ და ხელმისაწვდომობა",
        dish: "კერძის ბარათი",
        cart: "კალათა და გადახდა",
      },
    },
    monitors: {
      badge: "ეკრანები",
      title: "ეკრანები აჩვენებენ იმავე მენიუს",
      features: {
        playlist: "ვიდეო და ფოტო გრაფიკის მიხედვით",
        offline: "მუშაობს ინტერნეტის გარეშეც — USB მოწყობილობიდან",
        update: "შეცვალეთ კონტენტი ტელეფონიდან წამებში",
      },
      cta: "მეტი ეკრანების შესახებ",
      mockup: {
        menu_day: "დღის მენიუ",
        lunch: "ბიზნეს ლანჩი",
        action: "აქცია −15%",
        items: {
          lagman: "ხინკალი",
          plov: "ხაჭაპური",
          shashlik: "მწვადი",
          manti: "ლობიანი",
        },
      },
    },
  },
  components: {
    title: "იხდით მხოლოდ იმისთვის, რასაც იყენებთ",
    subtitle: "ტარიფის გეგმები არ არსებობს. ფასი თქვენი კომპონენტების ჯამია. დანარჩენი ყველაფერი შედის.",
    paid_title: "გამოწერის კომპონენტები",
    paid_note:
      "ფასები მითითებულია თვეში. საკუთარი მიწოდება, ოფიციანტის აპლიკაცია და QR მენიუ იყიდება ფილიალის მიხედვით.",
    free_title: "შედის — დამატებითი გადასახადის გარეშე",
    free_badge: "შედის",
    per_month: "ლარი/თვე",
    per_branch: "ფილიალზე",
    min_one: "მინიმუმ 1",
    cta: "შექმენით თქვენი კომპლექტი",
    items: {
      branches: { name: "ფილიალები", desc: "თითოეული ლოკაცია საკუთარი დარბაზითა და მარაგით" },
      employees: { name: "თანამშრომლები", desc: "ერთი ანგარიში თითოეულ ადამიანზე, მფლობელის ჩათვლით" },
      pos_devices: { name: "POS მოწყობილობები", desc: "სალარო მონობლოკზე, პლანშეტზე ან ტელეფონზე" },
      online_orders: {
        name: "საკუთარი მიწოდება",
        desc: "Telegram Mini App, ვებგვერდი და აპლიკაცია საკუთარ დომენზე",
      },
      waiter_app: {
        name: "ოფიციანტის აპლიკაცია",
        desc: "შეკვეთები პლანშეტიდან ან ტელეფონიდან, ცოცხალი სტოპ-ლისტით",
      },
      qr_menu: { name: "QR მენიუ", desc: "მენიუ და გადახდა სტუმრის ტელეფონიდან" },
      yandex: { name: "Yandex Eats", desc: "Yandex Eats-ის შეკვეთები ავტომატურად შემოდის" },
      monitors: { name: "მენიუს ეკრანები", desc: "ციფრული მენიუ და აქციები ნებისმიერ Smart TV-ზე" },
      warehouses: { name: "საწყობები", desc: "ინგრედიენტების აღრიცხვა რეცეპტის ბარათების მიხედვით" },
    },
    free_items: {
      kds: { name: "სამზარეულო (KDS)", desc: "მზარეულის ეკრანი ტაიმერებითა და რიგით" },
      manager_app: { name: "მენეჯერის აპლიკაცია", desc: "დარბაზის გეგმა და პერსონალი ტელეფონიდან" },
      loyalty_crm: { name: "ლოიალობა და CRM", desc: "სტუმრების ბაზა და ლოიალობის პროგრამა" },
      ai_analytics: { name: "AI ანალიტიკა", desc: "პროგნოზები და გაყიდვების რეკომენდაციები" },
      kiosk: { name: "თვითმომსახურების კიოსკი", desc: "სტუმრები თავად აფორმებენ შეკვეთას" },
      open_api: { name: "Open API", desc: "ინტეგრაციები საკუთარ სისტემებთან" },
      stop_list: {
        name: "რეალურ დროში სტოპ-ლისტი",
        desc: "მარაგის ამოწურვა ნიშნავს დამალვას ყველგან, ერთდროულად",
      },
      cash_shift: { name: "ცვლები და Z-ანგარიშები", desc: "გახსნა, დახურვა, სხვაობები" },
      order_management: { name: "შეკვეთების მართვა", desc: "შექმნა, ცვლილება, გაუქმება" },
      basic_analytics: { name: "ანალიტიკა", desc: "შემოსავალი, საშუალო ჩეკი, ტოპ კერძები" },
      order_status: { name: "შეკვეთის სტატუსის ეკრანი", desc: "სტუმრებისთვის დარბაზში" },
      e_kassa: { name: "E-Kassa (OFD)", desc: "ფისკალური ანგარიშგება უზბეკეთისთვის" },
      pin_protection: { name: "PIN-დაცული თანხის დაბრუნება", desc: "დაბრუნება საჭიროებს მენეჯერის დადასტურებას" },
      floor_plan: { name: "დარბაზის გეგმა და მაგიდები", desc: "ოთახის ვიზუალური განლაგება" },
      owner_push: { name: "მფლობელის push შეტყობინებები", desc: "შეტყობინებები დარღვევების შესახებ" },
      qr_generator: { name: "QR კოდის გენერატორი", desc: "მაგიდებისთვის — ბეჭდვა და ექსპორტი" },
      payment_types: { name: "გადახდის ტიპები", desc: "ნაღდი, ბარათი, QR" },
      receipt_printer: { name: "ქვითრის ბეჭდვა", desc: "ESC/POS, StarPRNT — ნებისმიერი აღჭურვილობა" },
    },
  },
  pricing: {
    tag: "ფასები",
    title: "ტარიფის გეგმები არ არსებობს. შექმენით საკუთარი კომპლექტი.",
    subtitle: "ფასი თქვენი კომპონენტების ჯამია. მინიმალური ვადა 3 თვეა.",
    from_label: "დან",
    per_month: "ლარი/თვე",
    from_note: "მინიმალურ კომპლექტზე, 12-თვიანი ვადით",
    term_title: "გადახდის ვადა",
    term_note: "მინიმუმ 3 თვე",
    build_title: "შექმენით თქვენი კომპლექტი",
    reset: "გასუფთავება",
    col_component: "კომპონენტი",
    col_unit: "ერთეულის ფასი",
    col_qty: "რაოდ.",
    col_sum: "ჯამი/თვე",
    brv_label: "BRV, UZS",
    brv_unit: "BRV",
    brv_note:
      "1 BRV = {{value}} UZS. ფასები მიბმულია BRV-ზე: მისი ცვლილებისას თანხა UZS-ში ავტომატურად გადაითვლება.",
    matrix_title: "თქვენი კომპლექტი ვადების მიხედვით",
    col_term: "ვადა",
    col_discount: "ფასდაკლება",
    col_per_month: "თვეში",
    col_total: "სულ",
    receipt_title: "ხარჯთაღრიცხვა",
    receipt_empty: "არაფერია არჩეული",
    receipt_base: "თვიური ფასი ფასდაკლებამდე",
    receipt_full: "{{months}} თვე ფასდაკლებამდე",
    receipt_discount: "ვადის ფასდაკლება",
    receipt_total_sub: "ლარი {{months}} თვეზე",
    receipt_per_month: "თვიური ფასი ფასდაკლების შემდეგ",
    receipt_save: "თქვენ დაზოგავთ",
    show_detail: "დეტალების ჩვენება",
    hide_detail: "დეტალების დამალვა",
    month_one: "თვე",
    month_few: "თვე",
    month_many: "თვე",
    rules_title: "როგორ იანგარიშება",
    rules: [
      "ფასი თქვენი კომპონენტების ჯამია. ტარიფის გეგმები არ არსებობს.",
      "მინიმალური შესყიდვის ვადა 3 თვეა.",
      "ვადის ფასდაკლება: 3 თვე −10%, 6 თვე −20%, 12 თვე −30%.",
      "ჯამი ყოველთვის მრგვალდება ქვემოთ.",
      "მინიმუმი: 1 ფილიალი, 1 თანამშრომელი, 1 POS მოწყობილობა.",
      "საკუთარი მიწოდება, ოფიციანტის აპლიკაცია და QR მენიუ იყიდება ფილიალის მიხედვით და ვერასდროს გადააჭარბებს თქვენი ფილიალების რაოდენობას.",
    ],
    notes_title: "ცალკე ირიცხება",
    notes: [
      "ონბორდინგი და დაყენება უფასოა — ამას ჩვენი გუნდი აკეთებს.",
      "აღჭურვილობა (მონობლოკი, პრინტერი, ეკრანები) იყიდება ცალკე. ეს ერთჯერადი ხარჯია და თანხა საკმაოდ განსხვავდება — დაგეხმარებით მის შერჩევაში თქვენი სივრცისა და ბიუჯეტის მიხედვით.",
    ],
    cta: "დაგვიკავშირდით",
    cta_note: "პირველი თვე უფასოა სრული კომპლექტით. შემდეგ მოქმედებს მინიმუმ 3-თვიანი ვადა.",
  },
  faq: {
    tag: "კითხვები",
    title: "ხშირად დასმული კითხვები",
    items: [
      {
        q: "როგორ გამოითვლება ფასი?",
        a: "ტარიფის გეგმები არ არსებობს. თქვენ ქმნით კომპლექტს რვა კომპონენტისგან და ფასი მათი ჯამია. მინიმალური შესყიდვის ვადა 3 თვეა, ხოლო ვადის ფასდაკლება შეადგენს: 3 თვე −10%, 6 თვე −20%, 12 თვე −30%. მინიმალური კომპლექტია 1 ფილიალი, 1 თანამშრომელი და 1 POS მოწყობილობა.",
      },
      {
        q: "რა შედის დამატებითი გადასახადის გარეშე?",
        a: "სამზარეულო (KDS), მენეჯერის აპლიკაცია, ლოიალობა და CRM, AI ანალიტიკა, თვითმომსახურების კიოსკი, Open API, სტოპ-ლისტი, ცვლები და Z-ანგარიშები, დარბაზის გეგმა, PIN-დაცული თანხის დაბრუნება, მფლობელის push შეტყობინებები და ქვითრის ბეჭდვა. იხდით მხოლოდ ფილიალებზე, თანამშრომლებზე, POS მოწყობილობებზე, საკუთარ მიწოდებაზე, ოფიციანტის აპლიკაციაზე, QR მენიუზე, ეკრანებზე და საწყობებზე.",
      },
      {
        q: "საწყობი მართლა ინგრედიენტებს ითვლის და არა პორციებს?",
        a: "დიახ. ყველა კერძს აქვს რეცეპტის ბარათი. როცა ხაჭაპურს ყიდით, საწყობიდან გამოიკლება ფქვილი, ყველი და მაწონი იმ რაოდენობით, რომელიც თქვენ მიუთითეთ. სწორედ ამიტომ საწყობის მაჩვენებელი რეალურია, თვითღირებულება ავტომატურად გამოითვლება, ხოლო სტოპ-ლისტი თავად შედგება, როგორც კი რომელიმე ინგრედიენტი მთავრდება.",
      },
      {
        q: "როგორ მუშაობს საკუთარი მიწოდება?",
        a: "თქვენ იღებთ საკუთარ პლატფორმას: Telegram Mini App-ს, ვებგვერდსა და მობილურ აპლიკაციას, სურვილის შემთხვევაში საკუთარ დომენზეც. შეკვეთები პირდაპირ ხვდება POS-სა და სამზარეულოში, იმავე მენიუზე და იმავე მარაგზე. ამ შეკვეთებზე აგრეგატორის საკომისიოს არ იხდით.",
      },
      {
        q: "რამდენ ხანში ხდება დანერგვა?",
        a: "ერთ კვირამდე. ჩვენი გუნდი აკეთებს ყველაფერს: გადავიტანთ მენიუს, ავაწყობთ რეცეპტების ბარათებს, დავაკავშირებთ აღჭურვილობას და გავწვრთნით თქვენს პერსონალს. ონბორდინგი უფასოა.",
      },
      {
        q: "საჭიროა აღჭურვილობის შეძენა?",
        a: "თუ ის უკვე არ გაქვთ — დიახ. მონობლოკი სალაროსთვის, ქვითრის პრინტერი და ეკრანები სამზარეულოსა და მენიუსთვის იყიდება ცალკე. ეს ერთჯერადი ხარჯია და თანხა საკმაოდ განსხვავდება, ამიტომაც არ შედის გამოწერაში. ზუსტად გეტყვით, რა სჭირდება თქვენს სივრცეს და მას თქვენს ბიუჯეტთან მოვარგებთ. Samly მუშაობს Android-სა და iOS-ზე, ასე რომ ჩვეულებრივი პლანშეტიც ნაწილს დაფარავს.",
      },
      {
        q: "მუშაობს ინტერნეტის გარეშე?",
        a: "POS და სამზარეულოს ეკრანი მუშაობს ინტერნეტის გარეშეც. მენიუს ეკრანებს კონტენტის დაკვრა შეუძლიათ USB მოწყობილობიდან. კავშირის აღდგენისთანავე მონაცემები თავად სინქრონიზდება — არცერთი შეკვეთა არ იკარგება.",
      },
      {
        q: "რა შედის უფასო თვეში?",
        a: "კომპონენტების სრული ნაკრები ერთი თვის განმავლობაში, ბარათისა და ვალდებულების გარეშე. თუ შემდეგაც დარჩებით, ძალაში შედის მინიმუმ 3-თვიანი ვადა.",
      },
      {
        // TODO(ge): the Samly apps have no Georgian UI yet (ru/uz/en only). Update once it ships.
        q: "რომელ ენებს უჭერს მხარს Samly?",
        a: "Samly-ის აპლიკაციები ხელმისაწვდომია რუსულ და ინგლისურ ენებზე. მხარდაჭერა პასუხობს რუსულად და ინგლისურად ტელეფონითა და Telegram-ით, ყოველდღე, კვირის გარდა, 09:00–21:00 საათებში, თბილისის დროით.",
      },
    ],
  },
  cta: {
    title: "მოგვცეთ საშუალება გაჩვენოთ Samly თქვენივე მენიუზე",
    subtitle: "პირველი თვე უფასოდ სრული კომპლექტით · ჩვენი გუნდი აწყობს ყველაფერს",
    note: "ონბორდინგი უფასოა. აღჭურვილობა იყიდება ცალკე — დაგეხმარებით მის შერჩევაში.",
    cta_primary: "დაგვიკავშირდით",
    cta_secondary: "დაგვირეკეთ",
    trust_payment: "ნაღდი · ბარათი · QR",
    trust_support: "მხარდაჭერა კვირაში 6 დღე",
    trust_local: "უკვე საქართველოში",
  },
  footer: {
    description:
      "ერთი მენიუ და ერთი საწყობის აღრიცხვა მთელი დაწესებულებისთვის: POS, საკუთარი მიწოდება, QR მენიუ, ოფიციანტის აპლიკაცია, ეკრანები და საწყობი.",
    product: "პროდუქტი",
    support: "მხარდაჭერა",
    contacts: "კონტაქტები",
    copyright: "ყველა უფლება დაცულია.",
    lang_label: "ენა",
    links: {
      features: "შესაძლებლობები",
      pricing: "ფასები",
      integrations: "ინტეგრაციები",
      modules: "რა შედის",
      apps: "აპლიკაციები",
      faq: "ხშირი კითხვები",
      contact: "დაგვიკავშირდით",
      telegram: "Telegram",
    },
  },
  contact: {
    title: "ვისაუბროთ თქვენს დაწესებულებაზე",
    subtitle: "დაგვირეკეთ ან მოგვწერეთ — გაჩვენებთ Samly-ს და ერთად დავაყენებთ.",
    call: "დაგვირეკეთ",
    telegram_label: "Telegram",
    instagram_label: "Instagram",
    hours_label: "სამუშაო საათები",
    hours: "ორშაბათი–შაბათი, 09:00–21:00 (თბილისის დრო)",
    trust: "პირველი თვე უფასოდ · ჩვენი გუნდი აწყობს ყველაფერს",
  },
  modal: {
    title: "სცადეთ Samly უფასოდ",
    subtitle: "დატოვეთ განაცხადი — მენეჯერი დაგიკავშირდებათ სამუშაო საათებში",
    name_placeholder: "თქვენი სახელი",
    phone_placeholder: "ტელეფონის ნომერი",
    submit: "განაცხადის გაგზავნა",
    submitting: "იგზავნება...",
    success_title: "განაცხადი მიღებულია!",
    success_desc: "მენეჯერი დაგიკავშირდებათ სამუშაო საათებში",
    error_required: "სავალდებულო ველი",
    error_name_min: "მინიმუმ 2 სიმბოლო",
    error_phone: "შეიყვანეთ სწორი ტელეფონის ნომერი",
    error_server: "შეცდომა. სცადეთ ხელახლა",
    toast_error_title: "გაგზავნა ვერ მოხერხდა",
  },
  apps: {
    title: "ჩვენი აპლიკაციები",
    subtitle: "სალარო — კომპიუტერზე, მფლობელისა და მიმტანის აპლიკაციები — ტელეფონზე.",
    pos: {
      title: "Samly სალარო Windows-ისთვის",
      desc: "პროგრამა სალაროს კომპიუტერისთვის: შეკვეთები, გადახდა, ჩეკის ბეჭდვა.",
      button: "ჩამოტვირთვა Windows-ისთვის",
      mobileHint: "დააინსტალირეთ სალაროს კომპიუტერზე",
    },
    owner: { title: "მფლობელის აპლიკაცია", desc: "შემოსავალი, ცვლები და ანგარიშები ყველა დაწესებულებისთვის — თქვენს ტელეფონში." },
    waiter: { title: "მიმტანის აპლიკაცია", desc: "შეკვეთების მიღება მაგიდასთან და სამზარეულოში გაგზავნა." },
    soon: "მალე",
    downloadOn: "ჩამოტვირთეთ",
    getItOn: "ხელმისაწვდომია",
  },
  installGuide: {
    title: "როგორ დავაინსტალიროთ სალარო",
    subtitle: "ჩამოტვირთვა დაიწყო. თუ Windows გაფრთხილებას გაჩვენებთ, ეს ნორმალურია — მიჰყევით ქვემოთ მოცემულ ნაბიჯებს.",
    subtitleHash: "ჩამოტვირთეთ ინსტალერი ქვემოთ მოცემული ღილაკით და მიჰყევით ნაბიჯებს. თუ Windows გაფრთხილებას გაჩვენებთ, ეს ნორმალურია.",
    steps: {
      browser: {
        title: "შეინახეთ ფაილი",
        text: "ბრაუზერმა შეიძლება დაწეროს, რომ ფაილს იშვიათად ტვირთავენ. დააჭირეთ „Keep“. Edge-ში: „…“ → „Keep“ → „Show more“ → „Keep anyway“.",
      },
      smartscreen: {
        title: "გახსენით ინსტალერი",
        text: "გაუშვით ჩამოტვირთული ფაილი. Windows გაჩვენებთ ფანჯარას „Windows protected your PC“. დააჭირეთ „More info“.",
      },
      runAnyway: {
        title: "დაუშვით გაშვება",
        text: "გამოჩნდება ღილაკი „Run anyway“. დააჭირეთ მას. ეს ფანჯარა ჩნდება, რადგან ინსტალერს ჯერ ციფრული ხელმოწერა არ აქვს.",
      },
      installer: {
        title: "დააინსტალირეთ სალარო",
        text: "Windows გკითხავთ, მისცეთ თუ არა აპლიკაციას ცვლილებების უფლება — დააჭირეთ „Yes“. გაიარეთ ინსტალაციის ყველა ნაბიჯი. სამუშაო მაგიდაზე გამოჩნდება Samly POS-ის მალსახმობი.",
      },
      connect: {
        title: "დააკავშირეთ სალარო",
        text: "გახსენით Samly POS და შეიყვანეთ დაკავშირების კოდი. კოდი არის ბექ-ოფისში: Branch settings → Devices.",
      },
    },
    retry: "ჩამოტვირთვა არ დაიწყო?",
    retryLink: "ხელახლა ჩამოტვირთვა",
    help: "ვერ აინსტალირებთ? მოგვწერეთ Telegram-ში",
    close: "გასაგებია",
  },
};

export default ka;
